export const additionalColors = {
  dotsIcon: '#fff',
};
